export const Civs: Array<{name: string}> = [
    {"name": "Armenians"},
    {"name": "Aztecs"},
    {"name": "Bengalis"},
    {"name": "Berbers"},
    {"name": "Bohemians"},
    {"name": "Britons"},
    {"name": "Bulgarians"},
    {"name": "Burgundians"},
    {"name": "Burmese"},
    {"name": "Byzantines"},
    {"name": "Celts"},
    {"name": "Chinese"},
    {"name": "Cumans"},
    {"name": "Dravidians"},
    {"name": "Ethiopians"},
    {"name": "Franks"},
    {"name": "Georgians"},
    {"name": "Goths"},
    {"name": "Gurjaras"},
    {"name": "Hindustanis"},
    {"name": "Huns"},
    {"name": "Incas"},
    {"name": "Italians"},
    {"name": "Japanese"},
    {"name": "Khmer"},
    {"name": "Lithuanians"},
    {"name": "Koreans"},
    {"name": "Magyars"},
    {"name": "Malay"},
    {"name": "Malians"},
    {"name": "Mayans"},
    {"name": "Mongols"},
    {"name": "Persians"},
    {"name": "Poles"},
    {"name": "Portuguese"},
    {"name": "Romans"},
    {"name": "Saracens"},
    {"name": "Sicilians"},
    {"name": "Slavs"},
    {"name": "Spanish"},
    {"name": "Tatars"},
    {"name": "Teutons"},
    {"name": "Turks"},
    {"name": "Vietnamese"},
    {"name": "Vikings"}
  ];